import { getConfig } from '@cian/config/browser';
import { getBaseUrlFromConfig } from './URI.js';
import { mergePaths, transformObjectToQuery, } from '../../../shared/index.js';
export function createURL(params) {
    const { model, subdomain, transformBodyToLegacyString } = params;
    const baseUrl = getBaseUrlFromConfig(getConfig(), model);
    const url = new URL(baseUrl);
    if (subdomain) {
        url.hostname = `${subdomain}.${url.hostname}`;
    }
    url.pathname = mergePaths(url.pathname, model.pathApi);
    if (model.method === 'GET' && model.parameters) {
        url.search = transformObjectToQuery(model.parameters, transformBodyToLegacyString);
    }
    return url;
}
//# sourceMappingURL=URL.js.map